import { arrow, computePosition, flip, offset, shift } from '@floating-ui/dom';

export default (config = {}) => {
    let showId = 0;

    return {
        positioned: false,
        placement: config.placement || 'top',

        show() {
            const id = ++showId;
            const arrowEl = this.$refs.arrow;

            computePosition(this.$refs.trigger, this.$refs.content, {
                placement: this.placement,
                strategy: 'fixed',
                middleware: [
                    offset(8),
                    flip(),
                    shift({ padding: 8 }),
                    arrow({ element: arrowEl }),
                ],
            }).then(({ x, y, placement, middlewareData }) => {
                if (showId !== id) return;

                Object.assign(this.$refs.content.style, {
                    left: `${x}px`,
                    top: `${y}px`,
                });

                const side = { top: 'bottom', right: 'left', bottom: 'top', left: 'right' }[placement.split('-')[0]];
                const { x: arrowX, y: arrowY } = middlewareData.arrow;

                Object.assign(arrowEl.style, {
                    left: arrowX != null ? `${arrowX}px` : '',
                    top: arrowY != null ? `${arrowY}px` : '',
                    [side]: '-4px',
                });

                this.positioned = true;
            });
        },

        hide() {
            showId++;
            this.positioned = false;
        },
    };
};
